import { useState } from 'react'

import { Sheet, SheetContent } from '@/shared/ui'

import { ContractorDetails } from '../../types'

import { BaseContractDetailsScreen } from './BaseContractDetailsScreen'
import { EditContactDetailsScreen } from './EditContactDetailsScreen'

type Screen = 'edit' | 'base'

type Props = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  contractor?: ContractorDetails
}

export const ContractDetailsSidebar = ({
  isOpen,
  onOpenChange,
  contractor,
}: Props) => {
  const [screen, setScreen] = useState<Screen>('base')

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent>
        {(() => {
          switch (screen) {
            case 'base':
              return (
                <BaseContractDetailsScreen
                  contractor={contractor}
                  setScreen={setScreen}
                />
              )

            case 'edit':
              return (
                <EditContactDetailsScreen
                  contractor={contractor}
                  setScreen={setScreen}
                />
              )

            default:
              return null
          }
        })()}
      </SheetContent>
    </Sheet>
  )
}
